export enum SettingsTab {
  USERS = 1,
  PROVIDERS = 2,
  COMPANIES = 3,
}
